import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Modal, message, Spin } from 'antd';
import ReactCodeInput from 'react-code-input';
import { CognitoUserPool } from 'amazon-cognito-identity-js';
import { POOL_DATA } from "../../../utils/config";

import './Confirm.css';

class Confirm extends Component {

  state = {
    visible: this.props.visible,
    code: '',
    display: 'none',
    type: '',
    loading: false
  };

  componentWillReceiveProps(thisProps) {
    if (thisProps.visible === true) {
      this.setState({
        visible: true
      })
    }
  }

  handleChange = (e) => {
    this.setState({
      code: e,
    });
  };

  handleSubmit = () => {
    const userPool = new CognitoUserPool(POOL_DATA);
    const cognitoUser = userPool.getCurrentUser();

    if (cognitoUser !== null) {
      cognitoUser.getSession((err, session) => {
        if (err) {
          message.error('The session has expired, please login again');
          this.props.history.push('/login');
          return;
        }
        if (session.isValid() === true) {
          this.setState({
            loading: true,
          });
          cognitoUser.verifyAttribute('phone_number', this.state.code, {
            onSuccess: () => {
              message.success('Successfully Set your phone number');
              this.setState({
                visible: false,
                loading: false,
              });
              this.props.getUserInfo();
              this.props.setConfirmVisible();
            },

            onFailure: (err) => {
              this.setState({
                loading: false,
              });
              if (err) {
                if (String(err).indexOf('Invalid verification code provided') !== -1 ) {
                  this.setState({
                    display: 'block',
                  });
                } else {
                  message.error(String(err).split(': ')[1]);
                }
              }
            }
          });
        } else {
          message.error('The session has expired, please login again');
          this.props.history.push('/login');
        }
      })
    } else {
      message.error('The session has expired, please login again');
      this.props.history.push('/login');
    }
  };

  handleResend = () => {

    const userPool = new CognitoUserPool(POOL_DATA);
    const cognitoUser = userPool.getCurrentUser();

    if (cognitoUser !== null) {
      cognitoUser.getSession((err, session) => {
        if (err) {
          message.error(String(err).split(': ')[1]);
          return;
        }
        if (session.isValid() === true) {
          cognitoUser.resendConfirmationCode((err, result) => {
            if (err) {
              message.error(String(err).split(': ')[1]);
              return;
            }
            message.success('Verification code has been sent, please check.')
          });
        }
      })
    }
  };

  handleCancel = (e) => {
    this.setState({
      visible: false,
    });
    this.props.getUserInfo();
    this.props.setConfirmVisible();
  };

  render() {
    return (
      <Modal
        visible={this.state.visible}
        className="Confirm"
        onCancel={this.handleCancel}
        key={this.props.key}
      >
        <h2>Confirm Your Phone Number</h2>
        <p>We've sent a SMS to your Phone, Fill in the verification code you received below</p>
        <Spin spinning={this.state.loading}>
          <div className="confirm-form">
            <ReactCodeInput type='number' fields={6} onChange={this.handleChange}/>
            <span style={{ display: this.state.display }}>Sorry, the Verification Code is wrong, check again or <a onClick={this.handleResend}>Resend</a></span>
            <button onClick={this.handleSubmit}>Confirm</button>
          </div>
        </Spin>
        <ul>
          <li>Did not receive? <a onClick={this.handleResend}>Resend</a></li>
          <li>Wrong phone number? <a onClick={this.handleCancel}>Back</a> and correct it.</li>
        </ul>
      </Modal>
    );
  }
}

export default withRouter(Confirm);



// WEBPACK FOOTER //
// ./src/Containers/Profile/components/Confirm.js